// extracted by mini-css-extract-plugin
export default {"root":"Characters_root__WDZ8O"};